import { CheckoutErrors, GeneralErrors } from 'interfaces/errors';

export default {
  'checkout:addresses:page-title': 'Pay for order',
  'checkout:addresses:title': 'Delivery details',
  'checkout:addresses:shipping-address': 'Shipping address',
  'checkout:addresses:deliver-address': 'Delivery address',
  'checkout:addresses:billing-address': 'Billing address',
  'checkout:addresses:shipping-address:edit': 'Edit',
  'checkout:addresses:shipping-address:choose-another-address':
    'Choose another address',
  'checkout:addresses:shipping-address:different-invoice-address':
    'Add different billing address',
  'checkout:addresses:shipping-address:different-invoice-address:choose-saved-address':
    'Choose saved address',
  'checkout:addresses:picker:choose-another-address': 'Choose another address',
  'checkout:addresses:picker:choose-address': 'Choose address',
  'checkout:addresses:picker:add-new-address': 'Add new address',
  'checkout:addresses:picker:to shipping': 'Continue to shipping',
  'checkout:addresses:picker:to free shipping': 'Continue to free shipping',
  'checkout:addresses:cross-sell:title': 'Would you like something extra?',
  'checkout:addresses:cross-sell:cta': 'Add to order',
  'checkout:addresses:cross-sell:item-added': 'Added',
  'checkout:addresses:validation-sheet:wrong-address:title':
    'Is your delivery address correct?',
  'checkout:addresses:validation-sheet:missing-address:title':
    'Oops, we could not find your address',
  'checkout:addresses:validation-sheet:wrong-address:subtitle':
    'We have checked your address entry and found an alternative. Please select the address to which your order should be sent.',
  'checkout:addresses:validation-sheet:missing-address:subtitle':
    'The address provided could not be found. Please check your entry to ensure that your delivery arrives without problems.',
  'checkout:addresses:validation-sheet:current-address':
    'Your entered address:',
  'checkout:addresses:validation-sheet:alternative-address': 'Our alternative:',
  'checkout:addresses:validation-sheet:cta-keep': 'Keep',
  'checkout:addresses:validation-sheet:cta-use-alternative': 'Apply',
  'checkout:addresses:validation-sheet:cta-edit': 'Edit address',
  'checkout:addresses:validation-sheet:cta-continue-with-address':
    'Continue with this address',

  'checkout:auth:continue-as-guest': 'Continue as guest',
  'checkout:auth:back-to-login': 'Back to login',
  'checkout:auth:signup:title': 'New to Pets Deli?',
  'checkout:auth:signup:title-2': 'Welcome to the Pets Deli family!',
  'checkout:auth:signup:sub-title':
    'Create an account now to complete your purchase.',
  'checkout:auth:signup:already-have-account': 'Already have an account?',
  'checkout:auth:signup:button:to-login': 'To Login',
  'checkout:auth:signup:button:to-login-2':
    'Already have an account? <span>Login</span>',
  'checkout:auth:signup:button:to-signup':
    'No account yet? <span>Create now</span>',
  'checkout:auth:signup:success-message':
    'Your account has been registered. Welcome to the Pets Deli Family!',
  'checkout:auth:login:title': 'Welcome back',
  'checkout:auth:login:title-2': 'Welcome back!',
  'checkout:auth:login:sub-title':
    'Log in with your Pets Deli account to pay for your order.',
  'checkout:auth:login:forgot-password': 'Forgot password?',
  'checkout:auth:login:button-login': 'Login',
  'checkout:auth:login:button-login-2': 'Login',
  'checkout:auth:login:button-otp': 'Login with one-time code',
  'checkout:auth:login:button-otp-2': 'Request one-time code',
  'checkout:auth:guest:title': 'Shop as guest',
  'checkout:auth:guest:title-2': 'Continue as guest',
  'checkout:auth:otp:title': 'Request one-time code',
  'checkout:auth:otp:button-request-otp': 'Send one-time code via email',
  'checkout:auth:otp:button-request-otp-2': 'Send code',
  'checkout:auth:otp:button-verify-otp': 'Verify code',
  'checkout:auth:otp:button-request-new-code': 'Request new code',
  'checkout:auth:otp:button-back-to-login': 'Back to login',
  'checkout:auth:otp:label-otp': '{digits}-digit code',
  'checkout:auth:otp:placeholder-otp': '{digits} digits',
  'checkout:auth:button-create-account': 'Create account',
  'checkout:auth:button-go-to-shipping': 'To delivery address',
  'checkout:shipping-and-payment:shipping:title': 'Shipping method',
  'checkout:shipping-and-payment:payment:title': 'Payment method',
  'checkout:shipping-and-payment:shipping:transparency-note':
    'Due to existing regulations, it is not possible for us to ship frozen goods via DHL. Please choose one of the following options for your shipment.',

  'checkout:summary:title': 'Complete purchase',
  'checkout:summary:submit-cta': 'Buy now',
  'checkout:summary:invoice-address': 'Billing address',
  'checkout:summary:cart-items:title': 'Items in this order',
  'checkout:summary:info-modal:price-calculation': 'Order summary',
  'checkout:summary:info-modal:first-order': 'First order',
  'checkout:summary:info-modal:original-price': 'Original price incl. VAT',
  'checkout:summary:info-modal:your-price': 'Your price incl. VAT',
  'checkout:summary:cart-items:every-further-delivery': 'Every further order',
  'checkout:summary:terms-and-conditions':
    'By placing your order, you agree to our <a>Terms & Conditions and Cancellation Policy</a>, as well as our <ad>Privacy Policy</ad>.',
  'checkout:summary:terms-and-conditions-checkbox':
    'Yes, I would like to be informed about promotions, vouchers and product news.<span>Unsubscribe at any time</span>',
  'checkout:summary:terms-and-conditions-whatsapp-checkbox':
    'I would like to receive promotions and news via WhatsApp.<span>Unsubscribe at any time</span>',

  'checkout:summary:guest:logout': 'Logout',

  'checkout:step:cart': 'Cart',
  'checkout:step:address': 'Address',
  'checkout:step:shipping': 'Shipping',
  'checkout:step:shipping-selection': 'Shipping options',
  'checkout:step:payment': 'Payment',
  'checkout:step:confirm': 'Confirmation',
  'checkout:step:continue-payment': 'Continue to payment',
  'checkout:CO2-information-title': 'We deliver CO₂-neutral.',
  'checkout:CO2-information-title-modal': 'We deliver CO₂ neutral',
  'checkout:CO2-information-text-modal':
    'Did you know that your package from us is always shipped 100% climate neutral? Whether DHL or DPD, the CO² emissions generated by the shipment of your order are calculated and offset by investing in certified climate protection projects. This means that the CO² produced is saved elsewhere.',
  'checkout:shipping:error-message': 'Please select a shipping method.',
  'checkout:shipping:error-message:unavailable_postcodes':
    'Unfortunately, we cannot currently ship your order to your address.',
  'checkout:shipping:error-message:frozen_packstation_error':
    'Due to existing regulations, it is not possible for us to deliver frozen goods via DHL to a Packstation. Please change your address in the previous step.',
  'checkout:payment:payment': 'Payment',
  'checkout:payment:loading':
    'Please wait and do not refresh or leave the page.',
  'checkout:payment:almost there': 'Almost there! How would you like to pay?',
  'checkout:payment:Your payment methods': 'Your payment methods',
  'checkout:payment:More payment options': 'More payment options',
  'checkout:payment:confirm order': 'CONFIRM ORDER',
  'checkout:payment:order:header': 'Pay for your order',

  'checkout:coupon:have-coupon': 'Add voucher',
  'checkout:coupon:have-coupon-test': 'I have a voucher',
  'checkout:coupon:added-successfully': 'Voucher added successfully',
  'checkout:coupon:remove-coupon': 'Remove',

  'checkout:coupon:coupon-code': 'Discount code',
  'checkout:coupon:coupon-code-placeholder': 'Enter voucher code here',
  'checkout:coupon:coupon-code-placeholder-test': 'Enter voucher code',
  'checkout:coupon:error:code_not_found': 'This voucher code is invalid.',
  'checkout:coupon:error:code_internal_usage_not_found': 'Invalid code',
  'checkout:coupon:error:code_expired': 'has expired',
  'checkout:coupon:error:code_exhausted_total': 'no longer redeemable',
  'checkout:coupon:error:code_exhausted_customer': 'no longer redeemable',
  'checkout:coupon:error:code_not_applicable_to_customer':
    'You cannot redeem this code at the moment. Please contact customer service.',
  'checkout:coupon:error:customer_fidelity_only_new_orders':
    'This coupon code is only valid for new customers.',
  'checkout:coupon:error:customer_fidelity_only_old_customers':
    'This coupon code is only valid for existing customers.',
  'checkout:coupon:error:basket_value_too_low':
    'Almost there, you are missing {amount} to redeem your voucher. Just browse our shop a little longer.',
  'checkout:coupon:error:No Items Applicable':
    'Voucher does not apply to selected products or subscriptions.',
  'checkout:coupon:error:shopid_mismatch': 'Not valid in this country',

  'checkout:payment:error:ABORT:default':
    'The payment was not successful. Please try again later or contact our customer service',
  'checkout:payment:error:TRY_OTHER_NETWORK:default':
    'The payment was not successful. Please use another payment method',
  'checkout:payment:error:TRY_OTHER_ACCOUNT:default':
    'The payment was not successful. Please use another payment account',
  'checkout:payment:error:TRY_OTHER_ACCOUNT:EXCEEDS_LIMIT':
    'This payment account does not have sufficient funds. Please use another account',
  'checkout:payment:error:TRY_OTHER_ACCOUNT:EXPIRED_ACCOUNT':
    'This payment account has expired. Please use another account',
  'checkout:payment:error:RETRY:default': 'An error occurred. Please try again',

  'checkout:bonus-program:title': 'Pets Deli Bonus Program',
  'checkout:bonus-program:redemption-product-points': '{value} POINTS',
  'checkout:bonus-program:confirm-page':
    'With the purchase you have received <span>{value} points</span>',
  'checkout:bonus-program:confirm-page-extra-bonus':
    'With the purchase you have received <span>{value} + {extraBonusPoints} points</span>',

  'checkout:bonus-program:confirm-page:create-account':
    'Create an account with Pets Deli now to access all the benefits of the bonus program.',
  'checkout:payment:error:authentication':
    'An error occurred! Please log in again and start a new payment process on the shopping cart page.',
  'checkout:express:bonus-program:confirm-page:total-points':
    'Your total points',
  'checkout:express:bonus-program:confirm-page:points-recap': '{value} points',
  'checkout:payment:optile-hints:paypal':
    'You will be redirected to PayPal to complete the order process',
  'checkout:bonus-program:confirm-page-extra-bonus-plus-newcustomer':
    'With the purchase you have received <span>{value} + {firstCustomerBonus} + {extraBonusPoints} points</span>',
  'checkout:bonus-program:confirm-page-newcustomer':
    'With the purchase you have received <span>{value} + {firstCustomerBonus} points</span>',

  'checkout:modal:abort-checkout:header':
    'Do you really want to cancel your purchase and go back to the shopping cart?',
  'checkout:modal:abort-checkout:button:continue': 'Continue shopping',
  'checkout:modal:abort-checkout:button:back-to-cart': 'To shopping cart',

  'checkout:funnel:header': 'Pay securely',

  'checkout:confirm:header': 'Thank you for your order',
  'checkout:confirm:sub-header':
    'We will notify you as soon as your shipment is on its way to you.',
  'checkout:confirm:button:continue-shopping': 'Continue browsing',
  'checkout:confirm:payment-method': 'Payment method',
  'checkout:confirm:payment-method:paypal': 'PayPal',
  'checkout:confirm:payment-method:pay_later': 'Klarna Invoice',
  'checkout:confirm:payment-method:pay_over_time':
    'Klarna Installment Purchase',
  'checkout:confirm:payment-method:pay_now': 'Klarna Pay Now',
  'checkout:confirm:payment-method:VISA': 'Visa',
  'checkout:confirm:payment-method:MASTERCARD': 'Mastercard',
  'checkout:confirm:payment-method:AMERICAN_EXPRESS': 'American Express',
  'checkout:confirm:payment-method:DINERS': 'Diners',
  'checkout:confirm:payment-method:DINERS_CLUB': 'JCB',
  'checkout:confirm:payment-method:DISCOVER': 'Discover',
  'checkout:confirm:payment-method:creditcard': 'Credit Card',
  'checkout:confirm:payment-method:twint': 'TWINT',
  [`checkout:general:error:${CheckoutErrors.CHECKOUT_EXPIRED}`]:
    'Your session has expired. Please try again by clicking on "Checkout".',
  [`checkout:general:error:${CheckoutErrors.CHECKOUT_NOT_FOUND}`]:
    'Something went wrong. Please try again by clicking on "Checkout".',
  [`checkout:general:error:${GeneralErrors.INTERNAL_SERVER_ERROR}`]:
    'Something went wrong. Please try again by clicking on "Checkout".',

  'checkout:order:payment:error:payment-failed':
    'The payment failed. Please try again.',
};